import { Typography } from "@mui/material";

const Bio = ({gradientValues, theme }) => (
    <Typography 
        align="justify"
        sx={{
            paddingTop: '0',
            paddingLeft: {
                md: theme === 'light' ? '1rem' : '0',
                xs: 0
            },
            paddingRight: {
                md: theme === 'light' ? '1rem' : '0',
                xs: 0
            },
            paddingBottom: {
                md: '1rem',
                xs: '2.5vw'
            }
        }}
    >
        This site documents my content and my weekly game-development experiences. 
        Each post is named after Monday, meaning each post covers MM/DD/YY to MM/DD+6/YY. 
        The name, layout, and colors of the site are inspired by the English 1989 Vintage publication of C.G. Jung's&nbsp;  
        <a 
            className='blogTitle' 
            href="https://www.bookfinder.com/isbn/9780679723950/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                ...gradientValues[0], 
                color: 'black', 
                paddingLeft: '4px',
                paddingRight: '4px',
            }}
        >
             pseudo-autobiography
        </a>
        &nbsp;and&nbsp;  
        <a 
            className='blogTitle' 
            href="https://cooper.edu"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                ...gradientValues[1], 
                color: 'black', 
                paddingLeft: '4px',
                paddingRight: '4px',
            }}
        >
            The Cooper Union.
        </a>
        &nbsp;For business inquiries,&nbsp;
        <a 
            className='blogTitle' 
            href="mailto:mdr.dev.email@gmail.com"
            style={{
                ...gradientValues[2], 
                color: 'black', 
                paddingLeft: '4px',
                paddingRight: '4px',
            }}
        >
            Click Here.
        </a>
    </Typography>
);

export default Bio;